<template>
    <Popup :open="open" :padding="true" @close="closePopup" @open="togglePopup">
        <Loading :loading="loading" preserve-height="true">
            <div>
                <p>
                    {{ title }}: <b>{{ paymentMethod ? $t(paymentMethod) : '' }}</b> <br /><br />
                    {{ message }} ({{ $t('addPaymentMethod_OptionOfDeletingOrChanging') }})
                </p>
                <div class="flex flex-wrap flex-row gap-4 mt-4">
                    <FormButton type="button" class="w-auto" styling="primary xs flex items-center gap-3 text-xs" :value="$t('plain_abort')" @click="closePopup"> </FormButton>
                    <FormButton type="button" class="w-auto" styling="secondary xs flex items-center gap-3 text-xs" :value="$t('plain_next')" @click="$emit('confirm')">
                    </FormButton>
                </div>
            </div>
        </Loading>
    </Popup>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        paymentMethod: {
            type: String,
            required: true
        }
    },
    emits: ['update:open', 'reload', 'confirm', 'cancel'],
    data() {
        return {
            loading: false
        };
    },
    methods: {
        closePopup() {
            this.$emit('update:open', false);
        },
        togglePopup() {
            this.$emit('update:open', !this.open);
        }
    }
};
</script>
